export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6655.a7314f58.jpg";